/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

type Props = {
  'data-testid'?: string;
  label: React.ReactChild;
  textColor: string;
  backgroundColor: string;
};

export const Pill = (props: Props) => {
  const { label, textColor, backgroundColor, ...otherProps } = props;

  return (
    <div
      data-testid={otherProps['data-testid']}
      css={css`
        background-color: ${backgroundColor};
        padding: var(--cds-spacing-50);
        width: fit-content;
        border-radius: var(--cds-spacing-50);
      `}
    >
      <Typography2 component="span" variant="subtitleMedium" style={{ color: textColor }}>
        {label}
      </Typography2>
    </div>
  );
};

export const LivePill = () => {
  return (
    <Pill
      label={['•', _t('Live Now')].join(' ')}
      textColor="var(--cds-color-red-750)"
      backgroundColor="var(--cds-color-red-50)"
    />
  );
};

export default Pill;
